import React from "react";
import PublishersFirstRef from "../../Partials/Reports/PublishersFirstRef";

const ListReportPublishers = () => {
  return <PublishersFirstRef />;
};

export default ListReportPublishers;
